// src/services/savedCreatorsService.js
import { apiRequest } from "./apiService";
import { buildQueryString } from "./queryString";

const toStr = (v) => String(v ?? "").trim();

export const listSavedCreators = (params = {}) => {
  const safeParams = {
    ...(params?.limit != null ? { limit: params.limit } : {}),
    ...(params?.last_key ? { last_key: params.last_key } : {}),
  };

  const qs = buildQueryString(safeParams); // "" or "?a=b"
  return apiRequest(`/saved-creators${qs}`, "GET");
};

export const toggleSavedCreator = ({ creatorId } = {}) => {
  const cid = toStr(creatorId);
  if (!cid) return Promise.reject(new Error("creatorId is required"));
  return apiRequest("/saved-creators/toggle", "POST", { creatorId: cid });
};